module.exports = __webpack_public_path__ + "static/media/gramophone.bcd40bbc.svg";